import { render, staticRenderFns } from "./ReviewsComponent.vue?vue&type=template&id=3ad09d0b"
import script from "./ReviewsComponent.vue?vue&type=script&lang=js"
export * from "./ReviewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports